import React, { Component } from "react";

class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PRODUCTS: this.props.PRODUCTS,
      productId: this.props.productId,
      productYieldError: false,
      productPriceError: false,
      price:
        this.props.PRODUCTS[Object.keys(this.props.PRODUCTS)[0]][0].price,
      yld: 1,
      finalProduct: false,
    };
  }

  // Yield
  checkProductYield = (e) => {
    const value = e.target.value;
    let error = true;
    const num = parseFloat(value);

    if (!isNaN(num) && num > 0) {
      error = false;
      this.setState({
        yld: num,
        productYieldError: false,
      });
      // propagate to parent (Process → StepForm) for mass-flow calc
      if (this.props.onYieldChange) {
        this.props.onYieldChange(this.props.productCat, num);
      }
    } else {
      this.setState({
        productYieldError: true,
        yld: value,
      });
    }
  };

  // Final product toggle
  checkFinalProduct = () => {
    const newValue = !this.state.finalProduct;
    this.setState({ finalProduct: newValue });

    this.props.onFinalProductChange &&
      this.props.onFinalProductChange(this.props.productCat, newValue);
  };

  // Price
  checkProductPrice = (e) => {
    const num = parseFloat(e.target.value);
    if (!isNaN(num) && num > 0) {
      this.setState({ price: num, productPriceError: false });
      this.props.onPriceChange &&
        this.props.onPriceChange(this.props.productCat, num);
    } else {
      this.setState({ productPriceError: true });
    }
  };

  updatePrice = (e) => {
    const num = parseFloat(e.target.value);
    this.setState({ price: num });
    this.props.onPriceChange &&
      this.props.onPriceChange(this.props.productCat, num);
  };

  render() {
    const {
      PRODUCTS,
      productId,
      productYieldError,
      productPriceError,
      finalProduct,
      price,
      yld,
    } = this.state;

    return (
      <div className="border rounded-lg p-3 mt-3 bg-white shadow-sm">
        <h3 className="font-semibold text-sm mb-2">
          Product {productId}: {this.props.productCat}
        </h3>

        {/* Product selector */}
        <div className="flex mb-2">
          <label className="w-40">Product</label>
          <select
            className="border rounded px-2 py-1 flex-1"
            onChange={this.updatePrice}
          >
            {Object.keys(PRODUCTS).map((k) => (
              <optgroup key={k} label={k}>
                {PRODUCTS[k].map((item, i) => (
                  <option key={i} value={item.price}>
                    {item.product}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </div>

          {/* YIELD FIELD */}
          <div className="flex items-center">
            <label
              htmlFor={"yield_" + productId}
              className="w-40 text-gray-700 font-medium"
            >
              Yield
            </label>
            <div className="flex-1">
              <input
                type="text"
                size="8"
                onChange={this.checkProductYield}
                value={yld}
                className={
                  "border rounded px-2 py-1 bg-yellow-100 w-32" +
                  (productYieldError ? " border-red-800" : "")
                }
                id={"yield_" + productId}
              />{" "}
              <span className="text-red-800 text-lg">*</span>{" "}
              <span className="text-gray-600 text-xs">
                (kg product / kg feed dw)
              </span>
              {productYieldError && (
                <span className="text-red-800 ml-2 text-xs">
                  Invalid value
                </span>
              )}
            </div>
          </div>

        {/* Final product */}
        <div className="flex mb-2">
          <label className="w-40">Final Product</label>
          <input
            type="checkbox"
            checked={finalProduct}
            onChange={this.checkFinalProduct}
          />
        </div>

        {/* Price */}
        {finalProduct && (
          <div className="flex">
            <label className="w-40">Price [EUR/ton]</label>
            <input
              className={
                "border px-2 py-1 w-32 " +
                (productPriceError ? "border-red-600" : "")
              }
              value={price}
              onChange={this.checkProductPrice}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ProductDetails;